<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="fe_invoice_payment.payment_id && fe_invoice_payment.payment_id > 0"
                            @invoke-method="dbGetFeInvoicePayment(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="fe_invoice_payment.payment_id && fe_invoice_payment.payment_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('fe_invoice_payments.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in fe_invoice_payment_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != fe_invoice_payment.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('fe_invoice_payments.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_fe_invoice_payment.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'fe_invoice_payments' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="fe_invoice_payment.status" class="ribbon ribbon-top-right" :class="`ribbon-${fe_invoice_payment.status_class}`">
                            <span class="ribbon-span">{{ fe_invoice_payment.status }}</span>
                        </div>
                        <v-form ref="formFeInvoicePayment">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="fe_invoice_payment_dialog"
                                    v-model="fe_invoice_payment.payment_id"
                                    :label="$t('lang.payment_id')"
                                    :counter="showCounter(fe_invoice_payment.payment_id, 'fe_invoice_payments.payment_id')"
                                    :rules="ifValid('fe_invoice_payments.payment_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="fe_invoice_payment.invoice_id"
                                    :label="$t('lang.invoice_id')"
                                    :items="invoices"
                                    item-value="invoice_id"
                                    item-text="invoice_id"
                                    :rules="ifValid('fe_invoice_payments.invoice_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="fe_invoice_payment.payment_term_id"
                                    :label="$t('lang.payment_term_id')"
                                    :items="payment_terms"
                                    item-value="payment_term_id"
                                    item-text="payment_term_id"
                                    :rules="ifValid('fe_invoice_payments.payment_term_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="fe_invoice_payment.payment_date"
                                    :label="$t('lang.payment_date')"
                                    :rules="ifValid('fe_invoice_payments.payment_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="fe_invoice_payment.currency_id"
                                    :label="$t('lang.currency_id')"
                                    :items="currencies"
                                    item-value="currency_id"
                                    item-text="currency_id"
                                    :rules="ifValid('fe_invoice_payments.currency_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="fe_invoice_payment.exchange_rate"
                                    :label="$t('lang.exchange_rate')"
                                    :counter="showCounter(fe_invoice_payment.exchange_rate, 'fe_invoice_payments.exchange_rate')"
                                    :rules="ifValid('fe_invoice_payments.exchange_rate')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="fe_invoice_payment.account_id"
                                    :label="$t('lang.account_id')"
                                    :items="chart_of_accounts"
                                    item-value="account_id"
                                    item-text="account_id"
                                    :rules="ifValid('fe_invoice_payments.account_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="fe_invoice_payment.notes"
                                    :label="$t('lang.notes')"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('fe_invoice_payments.notes')"
                                ></v-textarea>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'fe_invoice_payments' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveFeInvoicePayments">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_fe_invoice_payment"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_fe_invoice_payment')"
                :message="$t('lang.delete_fe_invoice_payment_confirm')"
                @onConfirm="deleteFeInvoicePayments()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_invoice_payment_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteFeInvoicePaymentDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            fe_invoice_payment: {},
            file_name: "",
            dbGetFeInvoicePayment: _.debounce(this.getFeInvoicePayment, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchFeInvoicePayment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice_payment) {
                        this.fe_invoice_payment = this.assignObj2(data.fe_invoice_payment, this.rules_fe_invoice_payments);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=fe_invoice_payment_status&sort_by=2",
                            method: "get",
                            stateProperty: "fe_invoice_payment_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "fe_invoice_payments", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchFeInvoicePayment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice_payment) {
                        next((vm) => {
                            vm.fe_invoice_payment = vm.assignObj2(data.fe_invoice_payment, vm.rules_fe_invoice_payments);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=fe_invoice_payment_status&sort_by=2",
                                method: "get",
                                stateProperty: "fe_invoice_payment_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "fe_invoice_payments", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=fe_invoice_payment_status&sort_by=2",
            method: "get",
            stateProperty: "fe_invoice_payment_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_fe_invoice_payments: (state) => state.fe_invoice_payments.rules_fe_invoice_payments,
            fe_invoice_payment_status_options: (state) => state.settings.fe_invoice_payment_status_options,
            fe_invoice_payments: (state) => state.fe_invoice_payments.fe_invoice_payments,
            selectedFeInvoicePayment: (state) => state.fe_invoice_payments.selectedFeInvoicePayment,
            invoices: (state) => state.invoices.invoices,
            payment_terms: (state) => state.payment_terms.payment_terms,
            currencies: (state) => state.currencies.currencies,
            chart_of_accounts: (state) => state.chart_of_accounts.chart_of_accounts,
        }),
    },
    methods: {
        ...mapActions([
            "fetchFeInvoicePayment",
            "saveFeInvoicePayment",
            "deleteFeInvoicePayment",
            "printFeInvoicePayment",
            "fetchInvoices",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchChartOfAccounts",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getFeInvoicePayment(pg_refresh = false) {
            this.startLoader();

            this.fetchFeInvoicePayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.fe_invoice_payment) {
                    this.fe_invoice_payment = this.assignObj2(data.fe_invoice_payment, this.rules_fe_invoice_payments);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printFeInvoicePayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_invoice_payment) {
                    if (this.dev_mode) {
                        this.file_name = data.fe_invoice_payment.file_name;
                    } else {
                        this.$refs.print.printReport(data.fe_invoice_payment.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveFeInvoicePayments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formFeInvoicePayment")) {
                    let body = this.prepForm(this.fe_invoice_payment, this.rules_fe_invoice_payments);

                    this.saveFeInvoicePayment({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.fe_invoice_payment) {
                            this.$router.push({ name: "fe_invoice_payment", params: { id: data.fe_invoice_payment.payment_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { payment_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveFeInvoicePayments({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_invoice_payment) {
                    this.fe_invoice_payment = this.assignObj2(data.fe_invoice_payment, this.rules_fe_invoice_payments);
                }
            });
        },
        deleteFeInvoicePayments() {
            this.deleteFeInvoicePayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "fe_invoice_payments" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchFeInvoicePayment({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice_payment) {
                        this.fe_invoice_payment = this.assignObj2(data.fe_invoice_payment, this.rules_fe_invoice_payments);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.invoices.length == 0 || force == true) await this.fetchInvoices({ body: { options: 1 } });
            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });
            if (this.chart_of_accounts.length == 0 || force == true) await this.fetchChartOfAccounts({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
